import { NexusRoutes } from '../routes';
import {
  AcceptInvitationRequest,
  AcceptInvitationResponse,
  PasswordResetMFARequest,
  PasswordResetMFAResponse,
  ResetPasswordConfirmRequest,
  ResetPasswordConfirmResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  SignInRequest,
  SignInResponse,
  UpdatePasswordRequest,
  UpdatePasswordResponse,
  UpdateUserDetailsRequest,
  UpdateUserDetailsResponse,
} from './APIClientInterface';
import { BaseAPIClient } from './BaseAPIClient';

export class APIClient extends BaseAPIClient {
  static async signInRequest(request: SignInRequest): Promise<SignInResponse> {
    const { client, config } = this.createClient();

    return client
      .post(NexusRoutes.SignIn, request, config)
      .then(httpResponse => {
        const response = this.prepareResponse<SignInResponse>(request, httpResponse);

        return response;
      })
      .catch(error => {
        return this.prepareResponse<SignInResponse>(request, error);
      });
  }

  static async updatePassword(request: UpdatePasswordRequest): Promise<UpdatePasswordResponse> {
    const { client, config } = this.createClient();

    return client
      .post(NexusRoutes.UpdatePassword, request, config)
      .then(httpResponse => {
        const response = this.prepareResponse<UpdatePasswordResponse>(request, httpResponse);

        return response;
      })
      .catch(error => {
        return this.prepareResponse<UpdatePasswordResponse>(request, error);
      });
  }

  static async resetPassword(request: ResetPasswordRequest): Promise<ResetPasswordResponse> {
    const { client, config } = this.createClient();

    return client
      .post(NexusRoutes.ResetPassword, request, config)
      .then(httpResponse => {
        const response = this.prepareResponse<ResetPasswordResponse>(request, httpResponse);

        return response;
      })
      .catch(error => {
        return this.prepareResponse<ResetPasswordResponse>(request, error);
      });
  }

  static async resetPasswordConfirm(request: ResetPasswordConfirmRequest): Promise<ResetPasswordConfirmResponse> {
    const { client, config } = this.createClient();

    return client
      .post(NexusRoutes.ResetPasswordConfirm, request, config)
      .then(httpResponse => {
        const response = this.prepareResponse<ResetPasswordConfirmResponse>(request, httpResponse);

        return response;
      })
      .catch(error => {
        return this.prepareResponse<ResetPasswordConfirmResponse>(request, error);
      });
  }

  static async passwordResetMFA(request: PasswordResetMFARequest): Promise<PasswordResetMFAResponse> {
    const { client, config } = this.createClient();

    return client
      .post(NexusRoutes.MultiFactorAuthentication, request, config)
      .then(httpResponse => {
        const response = this.prepareResponse<PasswordResetMFAResponse>(request, httpResponse);

        if (response.success) {
          response.multi_factor_authentication_request_uuid =
            httpResponse.data.multi_factor_authentication_request_uuid;
          response.last_four_digits_of_phone_number = httpResponse.data.last_four_digits_of_phone_number;
          response.multi_factor_authentication_factor = httpResponse.data.multi_factor_authentication_factor;
        }

        return response;
      })
      .catch(error => {
        return this.prepareResponse<PasswordResetMFAResponse>(request, error);
      });
  }

  static async acceptInvitation(request: AcceptInvitationRequest): Promise<AcceptInvitationResponse> {
    const { client, config } = this.createClient();

    return client
      .post(NexusRoutes.AcceptInvitation, request, config)
      .then(httpResponse => {
        const response = this.prepareResponse<AcceptInvitationResponse>(request, httpResponse);

        return response;
      })
      .catch(error => {
        return this.prepareResponse<AcceptInvitationResponse>(request, error);
      });
  }

  static async updateUserDetails(request: UpdateUserDetailsRequest): Promise<UpdateUserDetailsResponse> {
    const { client, config } = this.createClient();

    return client
      .put(NexusRoutes.UpdateUserDetails, request, config)
      .then(httpResponse => {
        const response = this.prepareResponse<UpdateUserDetailsResponse>(request, httpResponse);
        if (response.success) response.user = httpResponse.data;

        return response;
      })
      .catch(error => {
        return this.prepareResponse<UpdateUserDetailsResponse>(request, error);
      });
  }
}
